import React, {
    ReactElement,
    Component,
    useState,
    useEffect,
    Dispatch,
    SetStateAction,
    useContext,
    Fragment
} from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
    http_get,
    loading_alert_before,
    loading_alert_after,
} from '../common-file/service';
import './service-usage.less';
import { Row, Col, Select, Empty, Tooltip, Modal } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { DatacenternameContext } from "../../../contexts/datacenter-name";
import { datacenter_url } from "../../../components/top-navbar/interface";
import { EnvContext } from "../../../contexts/env";
import DropdownMenuSubscription from "../../../components/dropdown-menu-subscription/dropdown-menu-subscription";

// 全局变量
import { ServiceNameContext } from '../contexts/service-name-select';
import { SubscriptionSelectedContext } from '../contexts/subscription-selected';
// import {AppLocationContext} from '../contexts/app-location';
import { UserInfoContext, IUserInfoType } from "../../../contexts/user-info";
import { clusters_type_item, ClusterContext } from "../../../contexts/clusters";
import { ClusterSelectedContext } from "../../../contexts/cluster-selected";
import { WorkSpaceSelectedContext } from "../../../contexts/workspace-selected";
import { http_request } from "../../../worker/http-func";
import { item } from "../../../contexts/items";
import { workspaces_type_item, WorkspaceContext, workspaces_type } from "../../../contexts/workspaces";
import { select } from "../../../components/table-list/table-list";
import { NamespaceContext, namespaces_type_item } from "../../../contexts/namespaces";
import { NameSpaceSelectedContext } from "../../../contexts/namespace-selected";
import { WorkSpaceSelectContext } from "../../../contexts/workspace-select";
import { cry } from "../../../img";
import { useDeepCompareEffect} from 'use-deep-compare';

// data type
import { subscriptionType } from '../common-file/interfaceType';
// import {URLDataContext} from "../contexts/url-data";

const service_show_data: any = {
    RabbitMQ: true,
    MongoDB: true,
    PostgreSQL: true,
    AIFS: true,
    Blobstore: true,
    'EnSaaS-K8s-Service': true
};

const get_plan_service: any = {
    AIFS: true,
    Blobstore: true
};

// interface service_workspace_type {
//     key: string | number,
//     planName: string,
//     clusterName: string,
//     workspaceName: string,
//     workspaceId: string,
//     pnInfo: [],
//     licenseInstanceId: string,
// }

const ServiceUsage: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {

    const { intl } = props,
        subscription_selected: subscriptionType = useContext(SubscriptionSelectedContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        // app_location: string = useContext(AppLocationContext)[0],
        [service_name_list, set_service_name_list] = useState<any>([]),
        only_k8s_list = [{ key: 'EnSaaS-K8s-Service', name: 'EnSaaS-K8s-Service' }],
        [instance_list, set_instance_list] = useState([]),
        [instance_name, set_instance_name]: [string, Dispatch<SetStateAction<string>>] = useState('{}'),
        [service_name, set_service_name]: [string, Dispatch<SetStateAction<string>>] = useContext(ServiceNameContext),
        [pn_list, set_pn_list]: [any, Dispatch<SetStateAction<any>>] = useState([]),
        [pn_select, set_pn_select]: [string, Dispatch<SetStateAction<string>>] = useState(''),
        [iframe_src, set_iframe_src]: [string, Dispatch<SetStateAction<string>>] = useState(''),
        // [iframe_style, set_iframe_style]: [any, Dispatch<SetStateAction<any>>] = useState(''),
        [plan_selected, set_plan_selected]: [string, Dispatch<SetStateAction<string>>] = useState(''),
        [plan_list, set_plan_list]: [any, Dispatch<SetStateAction<any>>] = useState([]),
        env: datacenter_url | undefined = useContext(EnvContext)[0],
        // url_data: urlType = useContext(URLDataContext)[0];
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        [clusters, set_clusters]: [clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>] = useContext(ClusterContext),
        [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(WorkspaceContext),
        set_namespaces: React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>> = useContext(NamespaceContext)[1],
        [cluster_selected, set_cluster_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(ClusterSelectedContext),
        [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(WorkSpaceSelectedContext),
        set_namespace_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(NameSpaceSelectedContext)[1],
        [workspace_select, set_workspace_select]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useContext(WorkSpaceSelectContext),
        [nosubscription_modal_visible, set_nosubscription_modal_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [only_k8s, set_only_k8s]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);

    useEffect(() => {
        if (subscription_selected?.subscriptionId || user_info?.userSubscriptions?.length > 0 || user_info?.ssoSubscriptions?.length > 0) {
            set_nosubscription_modal_visible(false)
        } else if (user_info && user_info.ssoRole !== "globalAdmin" && user_info?.userSubscriptions?.length <= 0 && user_info?.ssoSubscriptions?.length <= 0) {
            setTimeout(() => {
                set_nosubscription_modal_visible(true)
            }, 3000);
        }
        // eslint-disable-next-line
    }, [subscription_selected?.subscriptionId, user_info?.userSubscriptions, user_info?.ssoSubscriptions]);

    // 为了登陆进来暂时先不直接显示ensaas-k8s-service,先在mp首页处理这里的逻辑，并存在session中, 后期可能还需要
    useEffect(() => {
        if(subscription_selected?.subscriptionId && user_info?.ssoSubscriptions) {
           return user_info?.ssoSubscriptions.find((item: any) => item.subscriptionId === subscription_selected?.subscriptionId) || user_info.ssoRole === "globalAdmin" ? set_only_k8s(false) : set_only_k8s(true);
        }
        // eslint-disable-next-line
    }, [subscription_selected?.subscriptionId, user_info?.ssoSubscriptions, user_info.ssoRole]);

// 获取service name
useDeepCompareEffect(() => {
        if(service_name_list.length <=0 ){
        //     console.log(subscription_selected?.subscriptionId , user_info?.ssoSubscriptions)
        //     const has_service = user_info?.ssoSubscriptions.find((item: any) => item.subscriptionId === subscription_selected?.subscriptionId) || user_info.ssoRole === "globalAdmin";
        //     if(has_service){
                (async () => {
                    loading_alert_before();
                    const { data } = await http_get('/serviceHub/v2/publisher/services', props) as any || {};
                    data?.push('EnSaaS-K8s-Service');
                    if (data) {
                        const service_name_session: string | null = service_name || sessionStorage.getItem('service_name');
                        const service_name_filter: any = data.filter((item: any) => service_name_session === item);
                        const list: any = [];
                        set_service_name(service_name_filter.length > 0 ? service_name_filter[0] : data[0]);
                        let reset_service: boolean = true;
                        // eslint-disable-next-line
                        data.map((item: any, key: number) => {
                            if (service_show_data[item]) {
                                list.push({
                                    key: key,
                                    name: item
                                });
                                if (service_name_session === item) {
                                    set_service_name(item);
                                    reset_service = false
                                }
                            }
                        });
                        reset_service && list[0] && set_service_name(list[0].name);
                        set_service_name_list(list);
                    }
                    loading_alert_after();
                })()
            // }else{
            //     const list_1 = [{ key: 'EnSaaS-K8s-Service', name: 'EnSaaS-K8s-Service' }]
            //     set_service_name(list_1[0].name);
            //     set_service_name_list(list_1); 
            // }
        }
        // const no_k8s_list = Array.isArray(service_name_list) ? service_name_list.filter((item: any) => item.name !== "EnSaaS-K8s-Service") : [];
        // if (sessionStorage.getItem("serviceUsage_only_k8s") === "only_k8s" || only_k8s ) {
        //     const list_1 = [{ key: 'EnSaaS-K8s-Service', name: 'EnSaaS-K8s-Service' }]
        //     set_service_name(list_1[0].name);
        //     set_service_name_list(list_1);
        // } else {
        //     if (no_k8s_list.length <= 0) {
                
        //     }
        // }
        // eslint-disable-next-line
    }, [service_name_list]);


    const return_plan_selected = () => {
        switch (service_name && service_name.toLowerCase()) {
            case 'mongodb': return 'Shared';
            case 'postgresql': return 'Shared';
            case 'rabbitmq': return 'standard';
            default: return '';
        }
    };

    useEffect(() => {
        if (get_plan_service[service_name] && user_info?.ssoSubscriptions?.length !== 0) {
            (async () => {
                loading_alert_before();
                const { data } = await http_get(`/serviceHub/v2/publisher/plans?displayName=${service_name}`, props) as any || {};
                const object_key: string[] = Object.keys(data || {});
                if (object_key.length > 0) {
                    let list: any = [];
                    // eslint-disable-next-line
                    object_key.map((key: string) => {
                        data[key]?.map((value: string, key: number) => 
                            list.push({
                                key,
                                value
                            })
                        )
                    });
                    set_plan_list(list);
                    set_plan_selected(list[0]?.value || '');
                } else {
                    set_plan_list([]);
                    set_plan_selected('')
                }
                loading_alert_after();
            })()
        } else if (only_k8s || service_name === "EnSaaS-K8s-Service") {
            if (workspace_selected) {
                let mp_planlist: any = [];
                if (cluster_selected?.labels?.type === "shared") {
                    mp_planlist = [{
                        key: 'General-Workspace',
                        value: 'General-Workspace'
                    }]
                } else {
                    mp_planlist = [{
                        key: 'Dedicated-Cluster',
                        value: 'Dedicated-Cluster'
                    }]
                }
                set_plan_list(mp_planlist);
                set_plan_selected(mp_planlist[0]?.value || '');
            } else {
                set_plan_list([]);
            }
        } else {
            set_plan_list([]);
            set_plan_selected(return_plan_selected())
        }
        // eslint-disable-next-line
    }, [service_name, workspace_selected, cluster_selected, only_k8s, user_info?.ssoSubscriptions]);

    const show_instance_option = (plan: string) => {
        if ((service_name === 'PostgreSQL' || service_name === 'MongoDB') && plan === 'shared') {
            return true
        } else if (service_name === 'RabbitMQ' && plan === 'standard') {
            return true
        } else if (get_plan_service[service_name]) {
            return true
        } else {
            return false
        }
    };

    const pn_list_filter = (list: any) => {
        let new_list: any = [];
        if (list && (service_name.toLowerCase() === 'aifs')) {
            for (let i = 0; i < list.length; i++) {
                const { pn } = list[i];
                if (pn !== '9806WPAFS0' && pn !== '9806WPAFS1') {
                    new_list.push({ ...list[i], key: i })
                }
            }
        } else {
            for (let i = 0; i < list.length; i++) {
                new_list.push({ ...list[i], key: i })
            }
        }
        return new_list;
    };

    useEffect(() => {
        if (service_name_list.length > 0 && subscription_selected?.subscriptionId && datacenter_name && plan_selected && plan_selected !== 'null' && service_name !== 'EnSaaS-K8s-Service') {
            (async () => {
                loading_alert_before();
                const { data } = await http_get(`/serviceHub/v2/subscriptions/${subscription_selected?.subscriptionId}/serviceInstances?serviceName=${service_name}&datacenterCode=${datacenter_name}&planName=${plan_selected.replace(/\+/g, '%2B')}`, props) as any || {},
                    instance_name_session: any = JSON.parse(sessionStorage.getItem('service_instance_name') || '{}');
                let reset_instance: boolean = true;
                if (data?.services) {
                    let list: any = [];
                    // eslint-disable-next-line
                    data.services.map((
                        {
                            serviceInstanceId,
                            serviceInstanceName,
                            pnInfo,
                            servicePlanName
                            // eslint-disable-next-line
                        }: any, key: any) => {
                        if (show_instance_option(servicePlanName.toLowerCase())) {
                            const new_pnInfo: any = pn_list_filter(pnInfo);
                            list.push({
                                key: key,
                                instanceId: serviceInstanceId,
                                instanceName: serviceInstanceName,
                                plan: servicePlanName,
                                pnInfo: new_pnInfo
                            });
                            if (serviceInstanceId === instance_name_session.instanceId) {
                                set_instance_name(JSON.stringify({
                                    key: key,
                                    instanceId: serviceInstanceId,
                                    instanceName: serviceInstanceName,
                                    plan: servicePlanName,
                                    pnInfo: new_pnInfo
                                }));
                                set_pn_list(pnInfo);
                                reset_instance = false
                            }
                        }
                    });
                    if (reset_instance && list[0]) {
                        const { pnInfo } = list[0];
                        set_instance_name(JSON.stringify(list[0]));
                        set_pn_list(pn_list_filter(pnInfo))
                    }
                    set_instance_list(list);
                    list.length <= 0 && set_pn_list([]);
                } else {
                    set_instance_name('{}');
                    set_instance_list([]);
                    set_pn_list([]);
                }
                loading_alert_after();
            })()
        }
        // eslint-disable-next-line
    }, [subscription_selected?.subscriptionId, datacenter_name, service_name_list, plan_selected, service_name]);

    useEffect((): void => {
        if (only_k8s || service_name === "EnSaaS-K8s-Service") {
            if (clusters?.length && subscription_selected?.subscriptionId) {
                const serviceUsage_clusters = clusters.filter((item: clusters_type_item) => item.subscriptionId === subscription_selected?.subscriptionId);
                if (serviceUsage_clusters?.length) {
                    const data: string = sessionStorage.getItem('cluster') || '',
                        selected = clusters.find((cluster: clusters_type_item) => cluster.metadata && cluster.metadata.name === data);
                    if (selected) set_cluster_selected(selected.metadata);
                    else {
                        const { metadata }: clusters_type_item = clusters[0];
                        set_cluster_selected(metadata);
                        sessionStorage.setItem('cluster', metadata?.name);
                    };
                } else {
                    set_clusters([]);
                    set_cluster_selected(undefined)
                }

            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clusters, set_cluster_selected, service_name]);

    useEffect((): void => {
        if (only_k8s || service_name === "EnSaaS-K8s-Service") {
            (async () => {
                if (cluster_selected?.name && datacenter_name && subscription_selected?.subscriptionId && user_info.role !== 'namespaceDeveloper') {
                    const { name }: item = cluster_selected;
                    // if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) || user_info.role === 'namespaceDeveloper') {
                    //     const workspacenames: { name: string, id: string }[] = (await http_request('workspacenames', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`, 0, user_info.role, subscription_selected?.subscriptionId, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true) as response_type).items as { name: string, id: string }[];
                    //     workspacenames && set_workspaces(workspacenames.map(({ name, id }) => { return { metadata: { name: id, labels: { name } } } as workspaces_type_item }));
                    // } else {
                    // name && user_info.role !== '' && datacenter_name !== '' && http_request('workspaces', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`, 0, user_info.role,subscription_selected?.subscriptionId, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true);
                    if (name && user_info.role !== '' && datacenter_name !== '') {
                        const workspace_new1 = ((await http_request('workspaces', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`, 0, user_info.role, subscription_selected?.subscriptionId, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true)) as unknown as workspaces_type)?.items;
                        workspace_new1?.filter(({ metadata }: workspaces_type_item) => metadata?.labels?.autoscale === "true")
                        set_workspaces(workspace_new1?.filter(({ metadata }: workspaces_type_item) => metadata?.labels?.autoscale === "true") || undefined);
                    }
                    // }
                }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cluster_selected?.name, set_workspaces, user_info.role, subscription_selected?.subscriptionId, user_info.wkOwner_has_namespacedeveloper, service_name]);

    // Workspace 下拉選單
    useEffect((): void => {
        if (!workspace_selected?.labels && workspaces?.length) {
            const workspace_found = workspaces.find(workspace => workspace.metadata.name === workspace_selected?.name);
            workspace_found && set_workspace_selected(workspace_found.metadata);
        }
        const workspace_select_new = ([
            workspaces && workspaces?.length > 0 ?
                <Select className="height-30 font-14" disabled={!workspaces.length} showSearch optionFilterProp="children" size="large" value={workspace_selected?.labels ? workspace_selected.labels.name : workspaces[0] && workspaces[0].metadata.labels?.name} style={{ width: '100%' }} onChange={(event: string) => { select(event, set_workspace_selected, true, workspaces); set_namespaces(undefined); set_namespace_selected(undefined) }}>
                    {workspaces[0] && workspaces.map((workspace: workspaces_type_item, index: number) => <Select.Option key={workspace.metadata.name + index} value={workspace.metadata.labels?.name}>{workspace.metadata.labels?.name}</Select.Option>)}
                </Select> : <Select key={'no_workspace'} value={intl.formatMessage({ id: 'no_workspace' })} disabled />,
            <Select className="height-30 font-14" disabled={!(workspaces || {}).length} value={workspace_selected?.labels ? workspace_selected.labels.name : workspaces && workspaces[0]?.metadata.labels?.name} style={{ width: '100%' }} onChange={(event: string) => { select(event, set_workspace_selected, true, workspaces); set_namespaces(undefined); set_namespace_selected(undefined) }}>
                {workspaces?.length && workspaces?.map((workspace: workspaces_type_item, index: number) => <Select.Option key={workspace.metadata.name + index} value={workspace.metadata.labels?.name}>{workspace.metadata.labels?.name}</Select.Option>)}
            </Select>
        ]);
        set_workspace_select(workspace_select_new as JSX.Element[]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workspace_selected, workspaces, set_workspace_selected, set_workspace_select, set_namespace_selected, set_namespaces]);

    useEffect(() => {
        if (pn_list && pn_list.length) {
            set_pn_select(pn_list[0].pn)
        } else {
            set_pn_select('');
        }

    }, [pn_list]);

    useEffect(() => {
        // set_service_name_list([]);
        // set_service_name('');
        set_clusters([])
        set_cluster_selected(undefined);
        set_workspaces([]);
        set_workspace_selected(undefined);
        set_plan_list([]);
        set_pn_list([]);
        set_pn_select('');
        // eslint-disable-next-line
    }, [subscription_selected?.subscriptionId])

    useEffect(() => {
        const { instanceId } = JSON.parse(instance_name);
        const mp_instanceId: string | undefined = cluster_selected?.name && workspace_selected?.name && (cluster_selected?.name + workspace_selected?.name);      
        if (service_name && subscription_selected?.subscriptionId && env?.["dashboard-monitoring"] && ((service_name !== "EnSaaS-K8s-Service" && pn_select && instanceId) || mp_instanceId)) {
            if (service_name !== "EnSaaS-K8s-Service" && !only_k8s) {
                pn_select && instanceId && set_iframe_src(`${env?.["dashboard-monitoring"].externalUrl}/dashboard/db/serviceusage-${service_name.toLowerCase()}?orgId=1&var-subscription_id=${subscription_selected?.subscriptionId}&var-service_name=${service_name}&var-instance_id=${instanceId}&var-pn=${pn_select}&theme=light&canSrp`);
            }
            if (service_name === "EnSaaS-K8s-Service" || only_k8s) {
                const dedicate_cluster_pn = "980GENDC000";
                const general_workspace_pn = "980GENGW100";
                const mp_pn = cluster_selected?.labels?.type === "shared" ? general_workspace_pn : dedicate_cluster_pn;
                mp_instanceId && set_iframe_src(`${env?.["dashboard-monitoring"].externalUrl}/dashboard/db/serviceusage-${'ensaas-k8s-service'}?orgId=1&var-subscription_id=${subscription_selected?.subscriptionId}&var-service_name=${'ensaas-k8s-service'}&var-instance_id=${mp_instanceId}&var-pn=${mp_pn}&theme=light&canSrp`);
            }
        } else {
            set_iframe_src('')
        }
        // eslint-disable-next-line
    }, [service_name, instance_name, pn_select, subscription_selected?.subscriptionId, env?.["dashboard-monitoring"], cluster_selected?.name, cluster_selected?.labels?.type, workspace_selected?.name, only_k8s]);

    // const iframe_style_fun = ()=>{
    //     const usage_box = document.getElementById('usage-box') || {offsetHeight: 0},
    //         select_box = document.getElementById('select-box') || {offsetHeight: 0};
    //     return {height: usage_box.offsetHeight - select_box.offsetHeight -50};
    // };

    // window.onresize = ()=>{
    //     set_iframe_style(iframe_style_fun())
    // };

    return (
        <div id={'usage-box'} className={'service-usage'}>
            <div>
                <Row id={'select-box'}>
                    <Col xs={24} sm={12} md={7} xxl={5}>
                        <DropdownMenuSubscription />
                    </Col>
                    <Col xs={24} sm={12} md={5} xxl={4}>
                        <div className={'select-label'}>
                            <FormattedMessage id={'service_name'} />
                        &nbsp;&nbsp;
                        <Tooltip title={intl.formatMessage({ id: 'service-usage-service-tooltip' })}>
                                <QuestionCircleOutlined className={'tooltip_question'} />
                            </Tooltip>
                        </div>
                        <Select
                            value={only_k8s? 'EnSaaS-K8s-Service': service_name}
                            onChange={(val: string) => {
                                set_service_name(val);
                                sessionStorage.setItem('service_name', val);
                                set_cluster_selected(undefined);
                                set_plan_selected('null');
                            }}
                        >{(only_k8s ? only_k8s_list: service_name_list).map((list: any) => (
                            <Select.Option key={list.name} value={list.name}>{list.name}</Select.Option>
                        ))}
                        </Select>
                    </Col>
                    {only_k8s || service_name === "EnSaaS-K8s-Service" ? "" : <Col xs={24} sm={8} md={4}>
                        <div className={'select-label'}>
                            <FormattedMessage id={'plan_sp'} />
                        </div>
                        <Select
                            value={plan_selected === 'null' ? '' : plan_selected}
                            onChange={(val: string) => set_plan_selected(val)}
                        >
                            {service_name && (service_name.toLowerCase() === 'mongodb' || service_name.toLowerCase() === 'postgresql') && <Select.Option value={'Shared'} title={'Shared'}>Shared</Select.Option>}
                            {service_name && service_name.toLowerCase() === 'rabbitmq' && <Select.Option value={'standard'} title={'standard'}>standard</Select.Option>}
                            {(get_plan_service[service_name]) && plan_list.map((item: any) => (<Select.Option value={item.value} key={item.value} title={item.value}>{item.value}</Select.Option>))}
                        </Select>
                    </Col>}
                    {
                        only_k8s || service_name === "EnSaaS-K8s-Service" ?
                            <Fragment>
                                <Col xs={24} sm={8} md={5} xxl={4}>
                                    <div className={'select-label'}><FormattedMessage id={'cluster_name'} /></div>
                                    {clusters.length > 0 ?
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            value={(cluster_selected || { name: '' }).name || clusters[0]?.metadata.name}
                                            disabled={!clusters.length}
                                            onChange={(event: string) => {
                                                const cluster_found = (clusters.find((cluster: clusters_type_item) => cluster.metadata.name === event) || {}).metadata;
                                                // set_role('');
                                                set_cluster_selected(cluster_found);
                                                set_workspaces(undefined);
                                                set_workspace_selected(undefined);
                                                sessionStorage.setItem('cluster', (cluster_found || {}).name || '');
                                                sessionStorage.removeItem('workspace');
                                            }}>
                                            {Array.isArray(clusters) && clusters
                                                .map((cluster: clusters_type_item) => <Select.Option key={cluster.metadata.name} value={cluster.metadata.name}>{cluster.metadata.name}</Select.Option>)}</Select> : <Select disabled value={intl.formatMessage({ id: 'no_cluster' })} />}
                                </Col>
                                <Col xs={24} sm={8} md={6} xxl={4}>
                                    <div className={'select-label'}><FormattedMessage id={'workspace_name'} /></div>
                                    {workspace_select[0]}
                                </Col>
                            </Fragment> :
                            <Col xs={24} sm={12} md={8} xxl={6}>
                                <div className={'select-label'}><FormattedMessage id={'instance_name'} /></div>
                                {instance_list.length > 0 ?
                                    <Select
                                        value={instance_name}
                                        onChange={(val: string) => {
                                            set_instance_name(val);
                                            sessionStorage.setItem('service_instance_name', val);
                                            set_pn_list(JSON.parse(val).pnInfo)
                                        }}
                                        showSearch
                                    >{instance_list.map((list: any) => (
                                        <Select.Option key={list.key}
                                            value={JSON.stringify(list)}
                                            title={list.instanceName}
                                        >{list.instanceName}</Select.Option>
                                    ))}</Select> : <Select disabled value={intl.formatMessage({ id: 'no_instance' })} />
                                }
                            </Col>
                    }
                    {only_k8s || service_name === "EnSaaS-K8s-Service" ? '' : <Col xs={24} sm={8} md={4}>
                        <div className={'select-label'}><FormattedMessage id={'pn'} /></div>
                        {pn_list && pn_list.length > 0 ?
                            <Select
                                value={pn_select}
                                onChange={(val: string) => set_pn_select(val)}
                            >{pn_list.map((list: any) => (
                                <Select.Option key={list.pn} value={list.pn}>{list.pn}</Select.Option>
                            ))}</Select> : <Select key={'no_pn'} value={intl.formatMessage({ id: 'no_pn' })} disabled />
                        }
                    </Col>}
                    {only_k8s || service_name === "EnSaaS-K8s-Service" ? <Col xs={24} sm={8} md={4}>
                        <div className={'select-label'}>
                            <FormattedMessage id={'plan_sp'} />
                        </div>
                        {plan_list.length > 0 && workspaces && workspaces.length ? <Select
                            value={plan_selected === 'null' ? '' : plan_selected}
                            onChange={(val: string) => set_plan_selected(val)}
                        >
                            {plan_list.map((item: any) => (<Select.Option value={item.value} key={item.value} title={item.value}>{item.value}</Select.Option>))}
                        </Select> : <Select key={'no_plan'} value={intl.formatMessage({ id: 'no_plan' })} disabled />}
                    </Col> : ''}
                </Row>

            </div>

            <div>
                {iframe_src ? <div className={'iframe-box px-20 card box_rounded border'}>
                    <iframe
                        id={'service-usage'}
                        title={`consumption-${service_name.toLowerCase()}`}
                        src={iframe_src}
                        className="service_size"
                    />
                </div> :
                    <Empty />}
            </div>
            <Modal
                visible={nosubscription_modal_visible}
                width={780}
                footer={null}
                centered={true}
                onCancel={() => set_nosubscription_modal_visible(false)}
                className="norole_modal"
            >
                <div className="no_role_div">
                    <img src={cry} alt="sorry" />
                    <span className="px-20"><FormattedMessage id="sorry_no_permission" /></span>
                </div>
            </Modal>
        </div>

    )
    // action={{service_management: true, secret_management: true, cancel_subscribe: true}}
};

export default injectIntl(ServiceUsage);
